import PropTypes from 'prop-types'
import { PropTypes as MobXPropTypes } from 'mobx-react'
import React, { Component } from 'react'

export default class ValueList extends Component {

  static propTypes = {
    list: MobXPropTypes.observableArray,
    type: PropTypes.string,
  }

  render() {

    const { type, list } = this.props

    const dataList = window.APP_CONFIG[`list_${type}`]

    if (!dataList) {
      console.log(`Unknown data list for type ${type}.`)
      return null
    }

    return (
      <ul className="list-styled">
        {list.map((entry) => {
          const value = dataList.find((dataListEntry) => dataListEntry.id === entry.id)
          return (
            <li key={entry.id}>
              {value.title}
              {('amount' in entry && entry.amount !== undefined && entry.amount !== 1)
                ? `: ${entry.amount}`
                : null}
            </li>
          )
        })}
      </ul>
    )
  }

}



// WEBPACK FOOTER //
// ./src/frontend/shared/components/ValueList.js